<template>
    <div class="ui-body">
        <div class="ui-home-panel">
            <el-row :gutter="15">
                <el-col :span="6">
                    <el-card shadow="hover" class="ui-card-default">
                        <div slot="header">
                            <span><i class="ion-ios-arrow-forward"></i>系统组织</span>
                            <el-tag effect="dark">个</el-tag>
                        </div>
                        <div class="content">
                            <span>{{organizeAnalysis.on}} / {{organizeAnalysis.off}}</span>
                            <p>开启：{{organizeAnalysis.percentage_on}}&nbsp;&nbsp;&nbsp;&nbsp;关闭：{{organizeAnalysis.percentage_off}}</p>
                            <i class="ion-logo-buffer ui-font-primary"></i>
                        </div>
                        <div class="footer">
                            <p>总数量：<span>0</span></p>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card shadow="hover" class="ui-card-default">
                        <div slot="header">
                            <span><i class="ion-ios-arrow-forward"></i>系统管理员</span>
                            <el-tag type="success" effect="dark">名</el-tag>
                        </div>
                        <div class="content">
                            <span>{{adminAnalysis.on}} / {{adminAnalysis.off}}</span>
                            <p>开启：{{adminAnalysis.percentage_on}}&nbsp;&nbsp;&nbsp;&nbsp;关闭：{{adminAnalysis.percentage_off}}</p>
                            <i class="ion-md-contact ui-font-success"></i>
                        </div>
                        <div class="footer">
                            <p>总数量：<span>0</span></p>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card shadow="hover" class="ui-card-default">
                        <div slot="header">
                            <span><i class="ion-ios-arrow-forward"></i>系统用户</span>
                            <el-tag type="warning" effect="dark">名</el-tag>
                        </div>
                        <div class="content">
                            <span>{{userAnalysis.on}} / {{userAnalysis.off}}</span>
                            <p>开启：{{userAnalysis.percentage_on}}&nbsp;&nbsp;&nbsp;&nbsp;关闭：{{userAnalysis.percentage_off}}</p>
                            <i class="ion-md-person ui-font-warning"></i>
                        </div>
                        <div class="footer">
                            <p>总数量：<span>0</span></p>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card shadow="hover" class="ui-card-default">
                        <div slot="header">
                            <span><i class="ion-ios-arrow-forward"></i>系统字典</span>
                            <el-tag type="danger" effect="dark">条</el-tag>
                        </div>
                        <div class="content">
                            <span>{{basicsAnalysis.on}} / {{basicsAnalysis.off}}</span>
                            <p>开启：{{basicsAnalysis.percentage_on}}&nbsp;&nbsp;&nbsp;&nbsp;关闭：{{basicsAnalysis.percentage_off}}</p>
                            <i class="ion-md-bookmarks ui-font-error"></i>
                        </div>
                        <div class="footer">
                            <p>总数量：<span>0</span></p>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div class="ui-home-content">
            <el-row :gutter="20">
                <el-col :span="18">
                    <el-card shadow="hover" class="ui-card-panel">
                        <div slot="header">
                            <span><i class="ion-ios-pulse"></i>平台API分析</span>
                        </div>
                        <div class="content">
                            <div id="visit_echarts" style="width: 100%;height:100%;"></div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card shadow="hover" class="ui-card-panel">
                        <div slot="header">
                            <span><i class="ion-ios-options"></i>平台API使用频次</span>
                        </div>
                        <div class="content">
                            <ul class="ui-ranking">
                                <li v-for="(item,index) in apiList" :key="index"
                                    :class="[{'one':(index===0)},{'two':(index===1)},{'three':(index===2)}]">
                                    <span>{{ item.title }}</span>
                                    <span class="number">{{ item.number }}</span>
                                </li>
                            </ul>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "home",
        data() {
            return {
                // 01.工作台分析 ------------------------------------------------
                // 01.01.工作台 - 系统组织
                organizeAnalysis: [],
                // 01.02.工作台 - 系统管理员
                adminAnalysis: [],
                // 01.03.工作台 - 系统用户
                userAnalysis: [],
                // 01.04.工作台 - 系统字典
                basicsAnalysis: [],
                // 02.平台API使用频次 ------------------------------------------------
                // 02.02.平台API使用频次 - 数据
                apiList: [],
                // 03.平台API分析图表 ------------------------------------------------
                // 03.01.用户流量图 - dom
                option: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#515A6E'
                            }
                        }
                    },
                    legend: {
                        data: ['GET', 'POST'],
                        itemGap: 20,
                        textStyle: {
                            fontSize: 16,
                            fontWeight: 'bold',
                            color: '#515A6E'
                        },
                        align: 'auto',
                        y: '3%'
                    },
                    grid: {
                        top: '13%',
                        left: '1%',
                        right: '3%',
                        bottom: '5%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: 'GET',
                            type: 'line',
                            stack: '总量',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                                opacity: 1,
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(2, 145, 255, 0.3)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(2, 145, 255, 0.9)'
                                }])
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: [140, 232, 101, 264, 90, 340, 250]
                        },
                        {
                            name: 'POST',
                            type: 'line',
                            stack: '总量',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                                opacity: 1,
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(68, 209, 253, 0.3)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(68, 209, 253, 0.9)'
                                }])
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: [120, 282, 111, 234, 220, 340, 310]
                        }
                    ]
                },
            }
        },
        // 监控data中的数据变化
        watch: {
            option: {
                handler(newVal, oldVal) {
                    if (this.chart) {
                        if (newVal) {
                            this.chart.setOption(newVal)
                        } else {
                            this.chart.setOption(oldVal)
                        }
                    } else {
                        this.visitEcharts()
                    }
                },
                deep: true // 对象内部属性的监听，关键。
            }
        },
        // 方法集合
        methods: {
            // 01.工作台 - 分析
            // 01.01.工作台 - 系统组织
            getOrganizeAnalysis() {
                this.$api.get("/api/get/organize-analysis/").then((response) => {
                    this.organizeAnalysis = response.data[0]
                })
            },
            // 01.02.工作台 - 系统管理员
            getAdminAnalysis() {
                this.$api.get("/api/get/admin-analysis/").then((response) => {
                    this.adminAnalysis = response.data[0]
                })
            },
            // 01.03.工作台 - 系统用户
            getUserAnalysis() {
                this.$api.get("/api/get/user-analysis/").then((response) => {
                    this.userAnalysis = response.data[0]
                })
            },
            // 01.04.工作台 - 系统字典
            getBasicsAnalysis() {
                this.$api.get("/api/get/basics-analysis/").then((response) => {
                    this.basicsAnalysis = response.data[0]
                })
            },
            // 02.工作台 - API使用频次
            // 02.01.获取平台API使用频次数据
            getRanking() {
                this.$api.get("/api/get/api-url-analysis/").then((response) => {
                    this.apiList = sortByKey(response.data, 'number')
                })
            },
            // 03.工作台 - API分析图表
            // 03.01.初始化平台API分析图表
            visitEcharts() {
                // 初始化eCharts实例
                this.chart = this.$echarts.init(document.getElementById('visit_echarts'), 'Aaron')
                // 使用配置项和数据显示图表
                this.chart.setOption(this.option, true)
            },
            // 03.02.获取平台API分析数据
            getDiagram() {
                this.$api.get("/api/get/api-type-analysis/", {'day': 7}).then((response) => {
                    this.option.xAxis.data = response.date
                    this.option.series[0].data = response.get_number
                    this.option.series[1].data = response.post_number
                })
            },
            // 04.工作台 - 自适应
            // 04.01.页面大小自适应
            pageAdapt(){
                window.onresize = () => {
                    this.chart.resize();
                }
            }
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 01.工作台 - 分析
            // 01.01.工作台 - 系统组织
            this.getOrganizeAnalysis()
            // 01.02.工作台 - 系统管理员
            this.getAdminAnalysis()
            // 01.03.工作台 - 系统用户
            this.getUserAnalysis()
            // 01.04.工作台 - 系统字典
            this.getBasicsAnalysis()
            // 02.01.获取平台API使用频次数据
            this.getRanking()
            // 03.02.获取平台API分析数据
            this.getDiagram()
            // 04.页面大小自适应
            // 04.01.页面大小自适应
            this.pageAdapt()
        },
    }

    // 数组对象排序
    function sortByKey(array, key) {
        return array.sort(function (a, b) {
            var x = a[key];
            var y = b[key];
            return ((x < y) ? 1 : ((x > y) ? -1 : 0));
        })
    }
</script>
